/* Lead-capture landing pages. Mounts the page's form (HubSpot or MailerLite) into #hs-lead-mount and sets the
 * HubSpot attribution fields from lead-pages-config.json, forms-config.json and the link that brought the visitor here
 * (cta, ctx, sub). Nothing from the URL reaches a visible contact field; UTM values are copied into lead_utm only. */
(function () {
  'use strict';
  var root = document.getElementById('hx-lead-page');
  if (!root) return;
  var mount = document.getElementById('hs-lead-mount');
  var status = document.getElementById('hx-lead-status');
  var heading = document.getElementById('hx-lead-heading');
  var panelIntro = root.querySelector('.hx-lead-panel-intro');
  var handle = root.getAttribute('data-page') || '';
  var params = new URLSearchParams(window.location.search);
  var pages = null, forms = null, page = null, scriptPromise = null;

  function setStatus(text, kind) {
    if (!status) return;
    status.textContent = text || '';
    status.className = 'hx-lead-status' + (kind ? ' is-' + kind : '');
  }
  function getJson(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(url + ' ' + r.status);
      return r.json();
    });
  }
  function loadScript(src, attrs) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src; s.async = true; s.defer = true;
      Object.keys(attrs || {}).forEach(function (k) { s.setAttribute(k, attrs[k]); });
      s.onload = resolve; s.onerror = function () { reject(new Error('script failed ' + src)); };
      document.head.appendChild(s);
    });
  }
  function utmString() {
    var out = [];
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(function (k) {
      var v = params.get(k); if (v) out.push(k.replace('utm_', '') + '=' + v.slice(0, 120));
    });
    return out.join(';');
  }
  function clean(v, max) { return (v || '').replace(/[<>"']/g, '').slice(0, max || 120); }

  function attribution() {
    var ctxKey = clean(params.get('ctx')) || page.defaultContext || 'Research';
    var ctx = (forms.contexts && forms.contexts[ctxKey]) || forms.contexts[page.defaultContext] || forms.contexts['Research'] || {};
    var request = page.form === 'quote' ? 'quote' : 'project';
    var intent = request === 'quote' ? forms.intentValues.quote : (ctx.projectIntent || forms.intentValues.project);
    var values = {
      research_audience: ctx.research_audience || '',
      lead_intent: intent,
      product_interest: (ctx.product_interest || []).join(';'),
      platform_context: ctx.platform_context || ctxKey,
      lead_cta_id: clean(params.get('cta')) || (handle + '-landing'),
      lead_source_page: window.location.href.split('#')[0].slice(0, 500),
      lead_source_section: clean(document.referrer, 200) || document.title.slice(0, 200),
      lead_utm: utmString(),
      source: 'Lead Capture Form',
      hs_language: (document.documentElement.lang || 'en').slice(0, 2),
      gtm_segment: ctx.gtm_segment || '',
      gtm_sub_segment: clean(params.get('sub'), 8)
    };
    if (page.fields) {
      var keep = {};
      page.fields.forEach(function (k) { if (k in values) keep[k] = values[k]; });
      return keep;
    }
    return values;
  }
  function setHidden(formEl, name, value) {
    var inputs = formEl.querySelectorAll('[name="' + name + '"]');
    if (!inputs.length) return false;
    inputs.forEach(function (input) {
      if (input.type === 'checkbox') input.checked = value.split(';').indexOf(input.value) !== -1;
      else { input.value = value; input.setAttribute('value', value); }
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    return true;
  }
  function styleButtons(formEl) {
    var doc = formEl && formEl.ownerDocument; if (!doc || doc.getElementById('hexo-form-button-colors')) return;
    var style = doc.createElement('style'); style.id = 'hexo-form-button-colors';
    style.textContent = '.hs-form .hs-button{background:#0088ce!important;border-color:#0088ce!important;color:#fff!important;transition:background-color .2s ease,border-color .2s ease}.hs-form .hs-button:hover,.hs-form .hs-button:focus-visible{background:#154067!important;border-color:#154067!important;color:#fff!important}.hs-form .hs-button:focus-visible{outline:3px solid #0088ce;outline-offset:3px}@media(prefers-reduced-motion:reduce){.hs-form .hs-button{transition:none}}';
    doc.head.appendChild(style);
  }
  function formEl(f) {
    var frame = mount.querySelector('iframe.hs-form-iframe');
    return (frame && frame.contentDocument && frame.contentDocument.querySelector('form')) || mount.querySelector('form') || (f && f.nodeType ? f : (f && f[0]));
  }
  /* HubSpot renders the form in a same-origin iframe whose height is not always synced to its content,
   * so the page keeps the frame as tall as the form (validation messages and the thank-you state included). */
  var fitTimer = null;
  function fitFrame() {
    var f = mount.querySelector('iframe');
    if (!f || !f.contentDocument || !f.contentDocument.documentElement) return;
    var h = f.contentDocument.documentElement.scrollHeight;
    if (h > 40 && Math.abs((parseInt(f.style.height, 10) || 0) - h) > 2) f.style.height = h + 'px';
  }
  function watchFrame() {
    fitFrame();
    var f = mount.querySelector('iframe');
    if (f && f.contentDocument && window.ResizeObserver && !f.__hxFit) {
      f.__hxFit = true;
      try { new ResizeObserver(fitFrame).observe(f.contentDocument.documentElement); } catch (e) {}
    }
    if (fitTimer) window.clearInterval(fitTimer);
    fitTimer = window.setInterval(fitFrame, 700);
  }
  function retryButton(fn) {
    var b = document.createElement('button'); b.type = 'button'; b.className = 'hx-lead-retry'; b.textContent = 'Retry';
    b.addEventListener('click', function () { b.remove(); fn(); });
    mount.appendChild(b);
  }

  function mountHubSpot() {
    var formId = page.formId || (forms.forms[page.form] && forms.forms[page.form].formId);
    if (!formId) { setStatus('This form is not configured. Please email sales@hexoskin.com.', 'error'); return; }
    var values = attribution();
    mount.setAttribute('aria-busy', 'true');
    setStatus('Loading the form…', 'loading');
    var ready = (window.hbspt && window.hbspt.forms) ? Promise.resolve() : (scriptPromise || (scriptPromise = loadScript(forms.embedScript)));
    ready.then(function () {
      window.hbspt.forms.create({
        region: forms.region, portalId: forms.portalId, formId: formId, target: '#hs-lead-mount',
        onFormReady: function (f) {
          var el = formEl(f); styleButtons(el);
          var apply = function () { var missing = []; Object.keys(values).forEach(function (k) { if (!setHidden(el, k, values[k])) missing.push(k); }); if (missing.length) console.warn('[lead-page] hidden fields not on form:', missing.join(', ')); };
          if (el) { apply(); window.setTimeout(apply, 500); el.setAttribute('data-hexo-cta', values.lead_cta_id || ''); }
          mount.removeAttribute('aria-busy'); setStatus('', '');
          watchFrame(); window.setTimeout(watchFrame, 600);
        },
        onFormSubmit: function (f) { var el = formEl(f); if (el) Object.keys(values).forEach(function (k) { setHidden(el, k, values[k]); }); setStatus('Sending…', 'loading'); },
        onFormSubmitted: function () { setStatus(page.thanks || 'Thank you. Your request has been received. We will reply by email within two business days.', 'success'); }
      });
    }).catch(function (err) {
      console.error('[lead-page]', err);
      mount.removeAttribute('aria-busy');
      setStatus('The form could not be loaded. Please retry, or email sales@hexoskin.com with your request.', 'error');
      scriptPromise = null; retryButton(mountHubSpot);
    });
  }

  function mountMailerLite() {
    var ml = page.mailerlite || {};
    if (!ml.account || !ml.form) { setStatus('This form is not configured.', 'error'); return; }
    setStatus('Loading the form…', 'loading');
    var box = document.createElement('div'); box.className = 'ml-embedded'; box.setAttribute('data-form', ml.form);
    mount.appendChild(box);
    if (!window.ml) {
      (function (w, d, e, u, f, l, n) { w[f] = w[f] || function () { (w[f].q = w[f].q || []).push(arguments); }; })(window, document, 'script', 'https://assets.mailerlite.com/js/universal.js', 'ml');
    }
    window.ml('account', ml.account);
    loadScript('https://assets.mailerlite.com/js/universal.js', { 'data-cookieyes': 'cookieyes-necessary' }).then(function () { setStatus('', ''); })
      .catch(function () { setStatus('The signup form could not be loaded. Please retry, or email sales@hexoskin.com to be added to the newsletter.', 'error'); retryButton(mountMailerLite); });
  }

  Promise.all([getJson(root.getAttribute('data-config')), getJson(root.getAttribute('data-forms-config'))]).then(function (res) {
    pages = res[0]; forms = res[1];
    page = pages.pages[handle];
    if (!page) { setStatus('This page has no form configured.', 'error'); return; }
    if (heading) heading.textContent = page.heading || '';
    if (panelIntro) panelIntro.textContent = page.intro || '';
    if (page.provider === 'mailerlite') mountMailerLite(); else mountHubSpot();
  }).catch(function (err) {
    console.error('[lead-page] config', err);
    setStatus('The form is unavailable right now. Please email sales@hexoskin.com with your request.', 'error');
  });
})();
